<template>
    <Layout>
        <div class="columns">
            <div class="column">
                <a href="/checkout/FAL_GM">Grow Monthly</a>
            </div>
            <div class="column">
                <a href="/checkout/FAL_GY">Grow Yearly</a>
            </div>
            <div class="column">
                <a href="/checkout/EXP_MONTHLY">Expert Monthly</a>
            </div>
            <div class="column">
                <a href="/checkout/EXP_YEARLY">Expert Yearly</a>
            </div>
        </div>
    </Layout>
</template>

<script>
    import Layout from "../shared/components/Layout";
    import Loading from "../shared/components/Loading";

    export default {
        components: {Layout, Loading},
        name: "PlansExample.vue"
    }
</script>

<style scoped>

</style>
